import { React, FC, useContext, useMemo} from 'external/react'
import {Button, styled} from 'external/material'

import { TeacherContext } from 'teacher/context'
import AddLessons from 'components/add-lessons'
import Lesson from './Lesson'
import confirmDialog from 'components/confirm-dialog'

const StyledLessons = styled('div')(lessonsStyles as any)

const Lessons: FC = () => {

    const {newPlan, updateState, section, translate, navigate, match} = useContext(TeacherContext) as any

    const lessonItems: any[] = useMemo(() => newPlan.content?.lessons || [],[newPlan.content])

    const updatePlan = (commands: any) => updateState({newPlan: commands})

    function deleteLesson (index: number, lesson:any) {
      confirmDialog({
        className: 'delete-field',
        translate: translate,
        children: (
          <div className="message">
            <div className="question">
              {translate('confirm_delete_item')}
            </div>
            <div className="title">
                {lesson.name}
            </div>
          </div>
        ),
        onConfirm: () => {
          updatePlan({content: {lessons: {$splice: [[index,1]]}}})
        }
      })
    }

    function addLessonClick() {
      navigate({section: 'add-lessons', activeTab: 'catalogue'}, match.path, { preserveQuery: true })
    }

    return (
      <StyledLessons className="planrd-lessons">
        <div className='label'>
            {translate('lessons')}
        </div>
        <Button onClick={addLessonClick} className='add-lessons' >+</Button>
        {section == 'add-lessons' ? <AddLessons activeTab='catalogue' /> : null}
        {lessonItems.length > 0 && (
          <div className="planrd-content">
          { lessonItems.map((lesson, index) => ( <Lesson key={index} onDeleteClick={() => deleteLesson(index, lesson)} id={lesson.id} name={lesson.name} />))}
          </div>
        )}
      </StyledLessons>
    )
  }


function lessonsStyles() {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px', alignItems: 'center',
    borderBottom: '1px solid #d8d8d8',
    '& .label': {
      alignSelf: 'flex-start',
      color: '#868c9c' 
    },
    '& .add-lessons': {
      backgroundColor: '#f0f7ff',
      border: '1px solid #a5b9de',
      color: '#a5b9de',
      width: '100%'
     },
     '& .planrd-content': {
        width: '100%',
     }
  }
}

export { Lessons as default }